// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-assessment-container{
    position: relative;
    width: 270px;
    min-height: 40px;
    border-radius: 10px;
    cursor: pointer;
    background-color: var(--blue-50);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
    .header-assessment-red{
        position: absolute;
        top: -20%;
        left: 95%;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        background-color: var(--accents-alizarin-red);

        display: flex;
        justify-content: center;
        align-items: center;

        font-family: Inter;
        font-weight: 600;
        color: white;
    }
    .header-assessment-container:hover {
        transform: scale(1.01); /* Scale up the button on hover */
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Increase shadow on hover for a lifted effect */
        transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transition for a polished feel */
    }

    .header-assessment-textcontainer{
        margin: 0px 10px 0px 10px;
    }

        .header-assessment-text{
            color: var(--White-Base, #FFF);
            text-align: center;
            /* Inter / 24 sp • H5 */
            font-family: Inter;
            font-size: 21px;
            font-style: normal;
            font-weight: 700;
            line-height: 36px;
        }

.modalAS-content {
    position: fixed;
    top: 80px;
    z-index: 99;
    left: calc(100% - 380px); 
    height: fit-content;
    background-color: var(--gray-20);

    display: inline-flex;
    flex-direction: column;
    justify-content: top;
    border-radius: 0 0 20px 20px;
    opacity: 0;
    max-height: 0;
    transition: max-height 1s ease, opacity 1s ease;
}
.modalAS-content.open {
    position: fixed;
    z-index: 99;
    top: 80px;
    margin-left: -70px;
    overflow-y: hidden;
    overflow-x: hidden;
    width: 303px;
    background-color: var(--gray-20);

    display: inline-flex;
    flex-direction: column;
    justify-content: top;
    max-width: 80%;
    border-radius: 0 0 20px 20px;
    opacity: 1;
    max-height: 500px;
    transition: max-height 0.5s ease, opacity 0.3s ease;
}

    .modalAS-content-dropdown {
        display: flex;
        z-index: 99;
        width: 100%;
        max-height: 300px;
        overflow: hidden;
        overflow-y: scroll;
        flex-direction: column;
        justify-content: top;
    }
    .modalAS-content-dropdown::-webkit-scrollbar {
        display: none;
    }

        .modalAS-content-ass {
            min-height: 40px;
            z-index: 99;
            width: 250px;
            border-radius: 10px;
            background-color: var(--blue-50);
            cursor: pointer;

            /* Text */
            font-family: Inter;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            color: white;

            /* Children */
            display: flex;
            justify-content: center; 
            align-items: center;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            padding: 0px 10px 0px 10px;
        }

            .modalAS-content-ass-ga {
                /* border: solid 1px black; */
                background: linear-gradient(var(--gray-30));
                box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.2);;
                width: 290px;
                border-radius: 10px;
                padding-top: 2%;
                margin-top: 1%;
                margin-bottom: 5%;
                margin-left: 2%;
                margin-right: 2%;
                text-align: center;
            }
            .modalAS-content-ass-ga-titel {
                font-family: Inter;
                color: black;
            }
            .modalAS-content-ass-einzel {
                margin: 1% 5% 5% 5%;
            }
            .modalAS-content-ass-einzel:hover {
            /* Your hover styles */
            content: attr(title);
            }
            .modalAS-content-ass-group {
                margin: 5% 3% 3% 3%;
            }
            .modalAS-content-ass:hover {
                transform: scale(1.01); /* Scale up the button on hover */
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Increase shadow on hover for a lifted effect */
                transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transition for a polished feel */
            }

            
            
            .disabled {
                pointer-events: none;
                opacity: 0.5; /* or any other visual indication */
              }

              `, "",{"version":3,"sources":["webpack://./src/widgets/ModalAssessmentStarten.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;AAC5C;IACI;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,6CAA6C;;QAE7C,aAAa;QACb,uBAAuB;QACvB,mBAAmB;;QAEnB,kBAAkB;QAClB,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,sBAAsB,EAAE,iCAAiC;QACzD,wCAAwC,EAAE,iDAAiD;QAC3F,iFAAiF,EAAE,0CAA0C;IACjI;;IAEA;QACI,yBAAyB;IAC7B;;QAEI;YACI,8BAA8B;YAC9B,kBAAkB;YAClB,uBAAuB;YACvB,kBAAkB;YAClB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;QACrB;;AAER;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,mBAAmB;IACnB,gCAAgC;;IAEhC,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;IACpB,4BAA4B;IAC5B,UAAU;IACV,aAAa;IACb,+CAA+C;AACnD;AACA;IACI,eAAe;IACf,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;;IAEhC,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;IACd,4BAA4B;IAC5B,UAAU;IACV,iBAAiB;IACjB,mDAAmD;AACvD;;IAEI;QACI,aAAa;QACb,WAAW;QACX,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,aAAa;IACjB;;QAEI;YACI,gBAAgB;YAChB,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,gCAAgC;YAChC,eAAe;;YAEf,SAAS;YACT,kBAAkB;YAClB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,YAAY;;YAEZ,aAAa;YACb,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,wCAAwC;YACxC,0BAA0B;QAC9B;;YAEI;gBACI,6BAA6B;gBAC7B,2CAA2C;gBAC3C,8CAA8C;gBAC9C,YAAY;gBACZ,mBAAmB;gBACnB,eAAe;gBACf,cAAc;gBACd,iBAAiB;gBACjB,eAAe;gBACf,gBAAgB;gBAChB,kBAAkB;YACtB;YACA;gBACI,kBAAkB;gBAClB,YAAY;YAChB;YACA;gBACI,mBAAmB;YACvB;YACA;YACA,sBAAsB;YACtB,oBAAoB;YACpB;YACA;gBACI,mBAAmB;YACvB;YACA;gBACI,sBAAsB,EAAE,iCAAiC;gBACzD,wCAAwC,EAAE,iDAAiD;gBAC3F,iFAAiF,EAAE,0CAA0C;YACjI;;;;YAIA;gBACI,oBAAoB;gBACpB,YAAY,EAAE,mCAAmC;cACnD","sourcesContent":[".header-assessment-container{\r\n    position: relative;\r\n    width: 270px;\r\n    min-height: 40px;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    background-color: var(--blue-50);\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}\r\n    .header-assessment-red{\r\n        position: absolute;\r\n        top: -20%;\r\n        left: 95%;\r\n        height: 20px;\r\n        width: 20px;\r\n        border-radius: 50%;\r\n        background-color: var(--accents-alizarin-red);\r\n\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        font-family: Inter;\r\n        font-weight: 600;\r\n        color: white;\r\n    }\r\n    .header-assessment-container:hover {\r\n        transform: scale(1.01); /* Scale up the button on hover */\r\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Increase shadow on hover for a lifted effect */\r\n        transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transition for a polished feel */\r\n    }\r\n\r\n    .header-assessment-textcontainer{\r\n        margin: 0px 10px 0px 10px;\r\n    }\r\n\r\n        .header-assessment-text{\r\n            color: var(--White-Base, #FFF);\r\n            text-align: center;\r\n            /* Inter / 24 sp • H5 */\r\n            font-family: Inter;\r\n            font-size: 21px;\r\n            font-style: normal;\r\n            font-weight: 700;\r\n            line-height: 36px;\r\n        }\r\n\r\n.modalAS-content {\r\n    position: fixed;\r\n    top: 80px;\r\n    z-index: 99;\r\n    left: calc(100% - 380px); \r\n    height: fit-content;\r\n    background-color: var(--gray-20);\r\n\r\n    display: inline-flex;\r\n    flex-direction: column;\r\n    justify-content: top;\r\n    border-radius: 0 0 20px 20px;\r\n    opacity: 0;\r\n    max-height: 0;\r\n    transition: max-height 1s ease, opacity 1s ease;\r\n}\r\n.modalAS-content.open {\r\n    position: fixed;\r\n    z-index: 99;\r\n    top: 80px;\r\n    margin-left: -70px;\r\n    overflow-y: hidden;\r\n    overflow-x: hidden;\r\n    width: 303px;\r\n    background-color: var(--gray-20);\r\n\r\n    display: inline-flex;\r\n    flex-direction: column;\r\n    justify-content: top;\r\n    max-width: 80%;\r\n    border-radius: 0 0 20px 20px;\r\n    opacity: 1;\r\n    max-height: 500px;\r\n    transition: max-height 0.5s ease, opacity 0.3s ease;\r\n}\r\n\r\n    .modalAS-content-dropdown {\r\n        display: flex;\r\n        z-index: 99;\r\n        width: 100%;\r\n        max-height: 300px;\r\n        overflow: hidden;\r\n        overflow-y: scroll;\r\n        flex-direction: column;\r\n        justify-content: top;\r\n    }\r\n    .modalAS-content-dropdown::-webkit-scrollbar {\r\n        display: none;\r\n    }\r\n\r\n        .modalAS-content-ass {\r\n            min-height: 40px;\r\n            z-index: 99;\r\n            width: 250px;\r\n            border-radius: 10px;\r\n            background-color: var(--blue-50);\r\n            cursor: pointer;\r\n\r\n            /* Text */\r\n            font-family: Inter;\r\n            font-size: 16px;\r\n            font-style: normal;\r\n            font-weight: 700;\r\n            color: white;\r\n\r\n            /* Children */\r\n            display: flex;\r\n            justify-content: center; \r\n            align-items: center;\r\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n            padding: 0px 10px 0px 10px;\r\n        }\r\n\r\n            .modalAS-content-ass-ga {\r\n                /* border: solid 1px black; */\r\n                background: linear-gradient(var(--gray-30));\r\n                box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.2);;\r\n                width: 290px;\r\n                border-radius: 10px;\r\n                padding-top: 2%;\r\n                margin-top: 1%;\r\n                margin-bottom: 5%;\r\n                margin-left: 2%;\r\n                margin-right: 2%;\r\n                text-align: center;\r\n            }\r\n            .modalAS-content-ass-ga-titel {\r\n                font-family: Inter;\r\n                color: black;\r\n            }\r\n            .modalAS-content-ass-einzel {\r\n                margin: 1% 5% 5% 5%;\r\n            }\r\n            .modalAS-content-ass-einzel:hover {\r\n            /* Your hover styles */\r\n            content: attr(title);\r\n            }\r\n            .modalAS-content-ass-group {\r\n                margin: 5% 3% 3% 3%;\r\n            }\r\n            .modalAS-content-ass:hover {\r\n                transform: scale(1.01); /* Scale up the button on hover */\r\n                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Increase shadow on hover for a lifted effect */\r\n                transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transition for a polished feel */\r\n            }\r\n\r\n            \r\n            \r\n            .disabled {\r\n                pointer-events: none;\r\n                opacity: 0.5; /* or any other visual indication */\r\n              }\r\n\r\n              "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
